module.exports = __webpack_public_path__ + "assets/webgl/LM_1_3.jpg.b716c825.webp";